import { Suspense, lazy } from 'react';
// import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// MyItarra
const Landscape = Loader(
  lazy(() => import('src/content/myitarra/mobile_landscape'))
);

const Portrate = Loader(
  lazy(() => import('src/content/myitarra/mobile_portrate'))
);

const myitarraMobileRoutes = [
  {
    path: 'landscape',
    element: <Landscape />
  },
  {
    path: 'portrate',
    element: <Portrate />
  }
];

export default myitarraMobileRoutes;
